<template>
<div class="chapter">
<div class="inner_page">
<div class="image_container">
<img alt="images" src="images/f000i-01.jpg"/>
<p class="caption"><em class="italic">Pzkpfw III tanks photographed in the Libyan desert in mid-1941. Other images of these vehicles show that they are from 1.Kompanie, Panzer-Regiment 5. Note the very patchy appearance of the camouflage, common at this time, and the canvas covers for the main gun and MG 34</em>.</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 01_Fm01.vue?3fd77762